<template>
    <div>       
        <div class="p-fluid p-formgrid p-grid">				 
            <div class="p-field p-col-12 p-md-3">                      
                <div class="p-field-checkbox">
                    <Checkbox v-model="selecionarTodasPermissoes" :binary="true" @change="checkboxSelecionarTodasPermissoes"/>
                    <label>Todas permissões selecionadas</label>
                </div>
            </div>
            <div class="p-field p-col-auto">
                <Button label="Permissões Excluidas" class="p-button-success" 
                    icon="pi pi-eye" title="Excluir" v-if="!selecionarTodasPermissoes" @click="exibirDialogPermExcluidas=true"/>  
            </div> 
        </div>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
                <label>Menu</label>
                <ScrollPanel style="width: 100%; height: 300px">
                    <Tree :value="itensMenu" :filter="true" filterMode="lenient" selectionMode="single" :selectionKeys.sync="idMenuSelecionado"
                        @node-select="selecionarMenu"></Tree>
                </ScrollPanel>                        
            </div>
            <div class="p-field p-col-12 p-md-6" v-if="exibirPermissoes">
                <label>Permissões - {{ menuSelecionado.nome }}</label>
                <div v-for="permissao of permissoesItemMenuSelecionado" :key="permissao.id">
                    <div class="p-field-checkbox">
                        <Checkbox :id="permissao.id" v-model="permissao.selecionado" :binary="true" @change="validarPermissaoSelecionada(permissao)"/>
                        <label>{{permissao.codigo}} - {{permissao.nome}}</label>
                    </div>
                </div>
            </div>
        </div>      
        <Dialog :visible.sync="exibirDialogPermExcluidas" header="Permissões Excluídas do Plano" :modal="true" :style="{width: '450px'}">
            <Listbox :options="plano.permissoesExcluidas" optionLabel="nome" listStyle="max-height:250px">
                <template #option="slotProps">
                    {{ slotProps.option.codigo }} - {{ slotProps.option.nome }}
                </template>
            </Listbox>
            <template #footer>
                <Button label="OK" icon="pi pi-check" @click="exibirDialogPermExcluidas=false"/>
            </template>
        </Dialog>       
    </div>
</template>

<script>

import MenuService from '@/service/MenuService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default { 
    menuService: null,
    props: {
        plano: {
            type: Object,
            require: true,
        }
    },
    data() {
		return {   
            exibirDialogPermExcluidas: false,			
            idMenuSelecionado: null,
            menuSelecionado: null,  
            exibirPermissoes: false,  
            selecionarTodasPermissoes: false,             
            permissoesItemMenuSelecionado: [],
            qtdPermissoesSelecionadas: 0,
            qtdPermissoes: 0,      
            itensMenu: [],
		}
	},
    methods: {   
        ...mapGetters('sessao', ['getDadosRequisicao']),
        listarMenu() {           
            this.exibirPermissoes = false;
            let requisicao = {
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }	
            this.menuService.listar(requisicao)
				.then(resp => {	
                   this.itensMenu = this.converterMenu(resp.data);
                })
                .catch(erro => {exibirMensagem(this, erro)});            
        },     
        checkboxSelecionarTodasPermissoes() {
            let recursivo = function rec(itensMenu, selecionar, permissoesSelecionadas) {               
                itensMenu.forEach(menu => {                   
                    menu.permissoes.forEach(perm => {
                        perm.selecionado = selecionar;
                        if(!selecionar) {
                            permissoesSelecionadas.push(perm);
                        }
                    });
                    if(menu.children.length > 0) {
                        recursivo(menu.children, selecionar, permissoesSelecionadas);
                    }
                });
            };
            // Se selecionarTodasPermissoes = true, então nenhuma será excluida do plano. A Lsta Plano.permissoesExcluidas será vazia.
            let permissoesSelecionadasExcluir = []
            recursivo(this.itensMenu, this.selecionarTodasPermissoes, permissoesSelecionadasExcluir);            
            this.qtdPermissoesSelecionadas = this.qtdPermissoes;
            this.plano.permissoesExcluidas = permissoesSelecionadasExcluir;
        },
        validarPermissaoSelecionada(permissao) {           
            if(permissao.nome.startsWith('Menu')) {
                // Se a permissão.selecionado = false, a mesma será incluida na lista de permissoesExcluidas do plano.                
                this.incluirExcluirPermissaoPlano([this.menuSelecionado], !permissao.selecionado);
            } else {      
                let encontrou = false;         
                let index = 0;
                for(let i = 0; i < this.plano.permissoesExcluidas.length; i++) {
                    let perm = this.plano.permissoesExcluidas[i];                   
                    if(perm.codigo == permissao.codigo) {
                        index = i;    
                        encontrou = true;   
                        break;
                    }
                }
                if(encontrou) {// Excluindo
                    this.qtdPermissoesSelecionadas++;
                    this.plano.permissoesExcluidas.splice(index, 1);
                } else {                    
                    // Incluindo na lista de permissões que serão excluidas do plano/perfil do usuário.
                    this.qtdPermissoesSelecionadas--;
                    this.plano.permissoesExcluidas.push(permissao);
                }
            }            
            if(this.qtdPermissoes == this.qtdPermissoesSelecionadas) {
                this.selecionarTodasPermissoes = true;
            } else {
                this.selecionarTodasPermissoes = false;
            }
        },
        incluirExcluirPermissaoPlano(itensMenu, inlcuirNaLista) {
            itensMenu.forEach(menu => {
                if(inlcuirNaLista) {
                    menu.permissoes.forEach(permissao => {
                        permissao.selecionado = false;
                        this.qtdPermissoesSelecionadas--;
                        this.plano.permissoesExcluidas.push(permissao);
                    });
                } else {// Exclui da lista                       
                    let index = 0;
                        menu.permissoes.forEach(permissao => {
                        permissao.selecionado = true;
                        this.qtdPermissoesSelecionadas++;
                        for(let i = 0; i < this.plano.permissoesExcluidas.length; i++) {
                            let perm = this.plano.permissoesExcluidas[i];
                            if(perm.codigo == permissao.codigo) {
                                index = i;    
                                break;
                            }
                        }
                        this.plano.permissoesExcluidas.splice(index, 1);                      
                    });                    
                }
                if(menu.menuFilhos.length > 0) {
                    this.incluirExcluirPermissaoPlano(menu.menuFilhos, inlcuirNaLista);
                }
            });
        },
        selecionarMenu(itemMenu) {      
            this.menuSelecionado = itemMenu.original;
            this.exibirPermissoes = true;
            this.permissoesItemMenuSelecionado = [];
            this.permissoesItemMenuSelecionado = itemMenu.permissoes;
        }, 
        converterMenu(itensConverter) {
            let itens = [];
            itensConverter.forEach(me => {                
                let objMenu = {
                    key: me.id,
                    label: me.nome,
                    data: me.nome,
                    icon: '',
                    children: (me.menuFilhos.length > 0 ? this.converterMenu(me.menuFilhos): []),
                    permissoes: me.permissoes,
                    original: me,
                }
                itens.push(objMenu);
                this.validarPermissaoComPlano(me.permissoes);
            });
            return itens;
        },
        validarPermissaoComPlano(permissoes) {
            this.qtdPermissoes += permissoes.length;
            permissoes.forEach(permissao => {
                permissao.selecionado = true;
                this.qtdPermissoesSelecionadas++;               
                for(let i = 0; i < this.plano.permissoesExcluidas.length; i++) {
                    let perm = this.plano.permissoesExcluidas[i];
                    if(perm.codigo == permissao.codigo) {
                        permissao.selecionado = false;
                        this.qtdPermissoesSelecionadas--;
                        break;
                    }
                }                     
            }); 
            if(this.qtdPermissoes == this.qtdPermissoesSelecionadas) {
                this.selecionarTodasPermissoes = true;
            } else {
                this.selecionarTodasPermissoes = false;
            }
        }      
    },
    created() {
        this.menuService = new MenuService();
        this.listarMenu();
    }     
}
</script>

<style>

</style>